import { useEffect, useState } from "react";
import { useDashboardStore } from "../../../../pages/hooks/useDashboardStore";
import { ForpoService } from "../service/ForpoService";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { Singleton } from "../../../../../core/services/Singleton";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { toast } from "react-toastify";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { MediaSlideItem } from "./MediaSlideItem";


export const MediaSlide = () => {
    const single = Singleton.getInstance()
    const { setLoading } = useDashboardStore();
    const service = new ForpoService();
    const [lista, setLista] = useState([]);
    const [bean, setBean] = useState<any>({});
    const [user, setUser] = useState<any>({});
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalConfirm, setModalConfirm] = useState<any>({ name: 'Confirmar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalslideitem, setModalslideitem] = useState<any>({ name: 'Item Slider', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' })

    const idBean = 'IDMediaSlide';

    const head = [

        { title: 'ID', property: idBean },
        // { title: 'ID', property: idBean, visible: false },
        { title: 'ID', property: 'Name' },
        { title: 'Descripción', property: 'Description' },
        { title: 'Fecha', property: 'Since' },
        { title: 'Código', property: 'Code' }



    ]

    useEffect(() => {
        setUser(single.getAccountID());
        getLista();
    }, [idBean])

    const setRowBean = (bean: any) => {
       //console.log("Row : ", bean);
        setBean(bean);
    }

    const getLista = () => {
        setLoading(true);
        service.getMediaSlideCatalogPorPropiedad('state', 1, null).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ErrorMessage) {
                    toast.error(resp.DataBeanProperties.ErrorMessage);
                }
                else if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
                setLoading(false);
            }
        )
    }

    const updateItem = () => {

        setModal({ ...modal, 'view': false });

        setLoading(true);
        service.updateMediaSlide(bean).subscribe(
            (resp: any) => {
                setLoading(false);
                if (resp.DataBeanProperties.ObjectValue) {
                    getLista();
                }
                single.update(bean);
            });
    }

    const eliminaritem = () => {
        bean.State = 2;
       //console.log(bean);
        updateItem();
        setModalConfirm({ ...modalConfirm, ['view']: false });
    }

    const agregarItem = () => {

        let b = {
            Name: '',
            Description: '',
            Since: single.getCurrenDate(),
            IDEmployee: user.IDAccount,
            State: 1,
            Code: '',



        }

        setBean(b);
        setModal({ ...modal, ['view']: true });

    }

    const iconButtons = [
        {
            nombre: "Agregar",
            visible: single.canCreate(),
            icono: "ri-file-add-line",
            evento: agregarItem,
        },
    ];
    const listaBotones = () => {
        const botones = [
            {
                titulo: "Editar",
                icono: "ri-file-list-line",
                visible: true,
                evento: () => {
                    setModal({ ...modal, view: true });
                },
            },
            {
                titulo: "Eliminar",
                icono: "ri-file-user-line",
                visible: true,
                evento: () => {
                    setModalConfirm({ ...modalConfirm, view: true });
                },
            },
            {
                titulo: "Imagenes",
                icono: "ri-image-line",
                visible: true,
                evento: () => {
                    setModalslideitem({ ...modalslideitem, view: true });
                },
            },
        ];
        return <ListMenu listaBotones={botones} />;
    };

    return (
        <>
            <BasicPage titulo="Configuración slider">
                <div className="row">
                    <div className="col-md-12 p-2">
                        <BasicTable listButtons={listaBotones()} iconButtons={iconButtons} head={head} body={lista} rowSet={setRowBean}></BasicTable>
                    </div>

                </div>
            </BasicPage>

            <Modal modal={modal} updateModal={setModal} eventModal={updateItem} >
                <>

                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <label className="form-label">Nombre</label>
                                <input type="text" className="form-control mt-2" value={bean.Name} onChange={(e) => { setBean({ ...bean, ['Name']: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Descripción</label>
                                <input type="text" className="form-control mt-2" value={bean.Description} onChange={(e) => { setBean({ ...bean, ['Description']: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Código Slide</label>
                                <input type="TEXT" className="form-control mt-2" value={bean.Code} onChange={(e) => { setBean({ ...bean, ['Code']: e.target.value }) }} />
                            </div>
                        </div>
                    </div>
                </>
            </Modal>

            <ModalConfirm modal={modalConfirm} updateModal={setModalConfirm} eventModal={eliminaritem}>
                {bean.Name}
            </ModalConfirm>

            <Modal modal={modalslideitem} updateModal={setModalslideitem}>
                <MediaSlideItem IDMediaSlideItem={bean[idBean]} codeMediaSlideItem={bean.Code} />
            </Modal>


        </>
    );
};
